import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparison } from '../data/salesCopy';
export function ComparisonSection() {
  return <section className="w-full border-y border-line bg-night-deep" data-id="element-42" data-mp="3e699y0owxsv2">
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-43" data-mp="39dpnee88zne4">
        <div className="text-center" data-id="element-44" data-mp="34g69xgjdjen8">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-45" data-mp="34f4uz0z8m808">
            Before vs. after
          </p>
          <h2 className="mx-auto mt-4 max-w-3xl font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-46" data-mp="2veq9a0id2qw7">
            Stop improvising. <span className="text-gold" data-id="element-47" data-mp="2qhq3lqpfbq5m">Start teaching from a system.</span>
          </h2>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-48" data-mp="2lj53dra696h6">
          <div className="rounded-2xl border border-line bg-panel p-5 sm:p-7" data-id="element-49" data-mp="omfoj5iuw11t">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-cream-muted" data-id="element-50" data-mp="jpyp3f67i09f">
              Without TeachersKit
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-51" data-mp="3egg8x17nn4yl">
              {comparison.map(row => <li key={row.without} className="flex items-start gap-3" data-id="element-52" data-mp="30gx0s8euftma">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-cream-muted" aria-hidden="true" data-id="element-53" data-mp="30j1d9eqt60y6" />
                  <span className="text-[15px] leading-relaxed text-cream-muted" data-id="element-54" data-mp="35i47e4592mrd">{row.without}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-gold/40 bg-panel-soft p-5 sm:p-7" data-id="element-55" data-mp="1xztk1i8j8au">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-56" data-mp="3jergf5ah93dn">
              With TeachersKit
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-57" data-mp="3ocsypo02wyo2">
              {comparison.map(row => <li key={row.with} className="flex items-start gap-3" data-id="element-58" data-mp="fxrdeivfniwr">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-59" data-mp="kqu8ivfuz0f2" />
                  <span className="text-[15px] font-medium leading-relaxed text-cream" data-id="element-60" data-mp="ukq2i76ti18b">
                    {row.with}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}